// React
import React, { useEffect, useState } from 'react';
import { Button, Col, Row, Table } from 'reactstrap';

// Containers Injections & Components
import { ModalFile } from './components/ModalFile';
import { ItemListFiles } from './components/itemListFiles';
import { ProposalsInjection } from '../../../../containers/proposalsInjection';
import {
  notifyError,
  ModalDelete,
  notifySuccess,
} from '../../../../containers/componentsInjection';

// Helpers
import * as url from '../../../../../../helpers/url_helper';
import { useLoading } from '../../../../../../hook/useLoading';
import { APIClient } from '../../../../../../helpers/api_helper';
import { useProfile } from '../../../../../../components/Hooks/UserHooks';

export const UploadFilesInfo = ({ id, isView, filesData, validation }) => {
  const [path, setPath] = useState(null);
  const [isOpen, setIsOpen] = useState(false);
  const [isVisible, setIsVisible] = useState(false);
  const [selectedFiles, setSelectedFiles] = useState([]);

  const api = new APIClient();
  const { userProfile } = useProfile();
  const { toggleLoading, setLoading } = useLoading();
  const { getFiles, deleteFiles, successFiles } = ProposalsInjection();

  function toggle() {
    setIsVisible(!isVisible);
  }

  function toggleDelete(path) {
    setIsOpen(!isOpen);
    setPath(path);
  }

  const handleSubmit = () => {
    toggleLoading();
    const formData = new FormData();

    formData.append('file', selectedFiles[0]);
    formData.append('proposal_id', id);

    api
      .create(url.BASE + 'proposal/upload', formData)
      .then((response) => {
        notifySuccess(response.message);
        toggle();
        setSelectedFiles([]);
        getFiles(id);
      })
      .catch((error) => {
        notifyError('Erro ao enviar arquivo');
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const handleDelete = () => {
    deleteFiles({ file: path });
    toggleDelete();
  };

  const handleDownload = async (path) => {
    toggleLoading();
    await fetch(
      url.BASE + `/proposal/download?file=${encodeURIComponent(path.fullPath)}`,
      {
        method: 'GET',
        headers: {
          Authorization: userProfile?.data.token,
        },
      }
    )
      .then((response) => response.blob())
      .then((blob) => {
        const a = document.createElement('a');
        document.body.appendChild(a);
        const url = window.URL.createObjectURL(blob);
        a.href = url;
        a.download = encodeURIComponent(path.name);
        a.click();
      })
      .catch((err) => {
        return err;
      })
      .finally(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
    if (id) {
      getFiles(id);
    }
  }, [getFiles, id, successFiles]);

  return (
    <Row>
      <Col md={12}>
        <p className="h4 mb-4">Arquivos</p>
      </Col>
      <div>
        {id && (filesData || []).length > 0 ? (
          <Table
            className="invoice-table table-borderless table-nowrap mb-0"
            responsive
          >
            <thead className="align-middle">
              <tr className="table-active">
                <th scope="col" style={{ width: '50px' }}>
                  #
                </th>
                <th scope="col">Nome</th>
                <th scope="col">Tamanho</th>
                <th scope="col">Data da última alteração</th>
                <th />
              </tr>
            </thead>
            <tbody id="table">
              {filesData.map((item, index) => (
                <ItemListFiles
                  key={index}
                  item={item}
                  index={index}
                  isView={isView}
                  handleDelete={toggleDelete}
                  handleDownload={handleDownload}
                />
              ))}
            </tbody>
          </Table>
        ) : (
          <div>
            <p className="ms-2">Nenhum arquivo cadastrado</p>
          </div>
        )}
        {!isView && id && (
          <Button
            className="btn btn-soft-secondary fw-medium"
            id="add-item"
            onClick={() => {
              toggle();
            }}
          >
            <i className="ri-add-fill me-1 align-bottom"></i> Adicionar arquivo
          </Button>
        )}

        <ModalFile
          toggle={toggle}
          isVisible={isVisible}
          filesData={filesData}
          validation={validation}
          handleSubmit={handleSubmit}
          selectedFiles={selectedFiles}
          setSelectedFiles={setSelectedFiles}
        />

        <ModalDelete
          isOpen={isOpen}
          toggle={toggleDelete}
          handleDelete={handleDelete}
          goBack={() => toggleDelete()}
        />
      </div>
    </Row>
  );
};
